import { get, flow, replace } from 'lodash/fp';

export default {
  js: flow(get(['js']), replace(/(<script\b[^>]*>)|(<\/script>)/gi, '\n;\n')),
};
